import React, { useMemo } from 'react';
import { Alert } from './styledComponents';

interface TimedBannerProps {
  startDate?: string;
  endDate?: string;
  type?: 'success' | 'info' | 'warning' | 'error';
  fixed?: boolean;
  zIndex?: number;
  children: React.ReactNode;
}

const TimedBanner: React.FC<TimedBannerProps> = ({
  startDate,
  endDate,
  type = 'warning',
  fixed = false,
  children,
  zIndex,
}) => {
  const isVisible = useMemo(() => {
    // At least one of the dates must be provided
    if (!startDate && !endDate) {
      return false;
    }

    const now = Date.now();
    let validStartDate = true;
    let validEndDate = true;

    if (startDate) {
      const start = Date.parse(startDate);
      validStartDate = !isNaN(start) && now >= start;
    }

    if (endDate) {
      const end = Date.parse(endDate);
      validEndDate = !isNaN(end) && now <= end;
    }

    return validStartDate && validEndDate;
  }, [startDate, endDate]);

  if (!isVisible) {
    return null;
  }

  return (
    <Alert type={type} fixed={fixed} zIndex={zIndex}>
      {children}
    </Alert>
  );
};

export { TimedBanner };
